<template>
  <!-- Your Chat Plugin code -->
  <div class="fb-customerchat"
    attribution="setup_tool"
    page_id="115582340162554"
    theme_color="#4FD1C1">
    
  </div>
</template>